import { Navigate, Outlet } from 'react-router-dom';
import { storage } from '@/services/storageService';

function getStoredSession() {
  const token = storage.get<string>('token');
  const user = storage.get<{ user?: unknown }>('user');
  const hasUser = Boolean(user?.user);
  return { token, user, hasUser, isValid: Boolean(token && hasUser) };
}

export function GuestMiddleware() {
  const { isValid, token, user } = getStoredSession();

  if (isValid) {
    return <Navigate to="/app" replace />;
  }

  // Sessão incompleta (ex.: token sem user) — limpa e segue no login
  if (token || user) {
    storage.clear();
  }

  return <Outlet />;
}

export function AuthMiddleware() {
  const { isValid, hasUser } = getStoredSession();

  // A cada carregamento de rota autenticada: exige key do user logado
  if (!isValid || !hasUser) {
    storage.clear();
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
}
